<!-- <p>analytics-container works!</p> -->
<div
  [ngClass]="{
    'analytics-component-container': screenSize == ScreenType.Desktop,
    'analytics-component-container-tablet': screenSize == ScreenType.Tablet,
    'analytics-component-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <!-- <button (click)="onAnalyticsInformation()" mat-raised-button>Open</button>  -->
  <mat-tab-group
    class="custom-tabs"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
  >
    <mat-tab label="Re-Answer Analytics">
      <div class="analytics-container-component">
        <app-analytics-information-dialog
          (saveQuestions)="onAnalyticsInformation($event)"
          [analyticsData]="analyticsState.riskQuestions"
          [isDataLoaded]="analyticsState.status.isRiskAnalyticsDataLoaded"
        >
        </app-analytics-information-dialog>
      </div>
    </mat-tab>
    <mat-tab label="RISK VIEW">
      <app-risk-view-analyticss
        [analyticsData]="analyticsState"
      ></app-risk-view-analyticss>
    </mat-tab>
    <mat-tab label="RISK PROFILE"
      ><app-risk-dashboard [analyticsData]="analyticsState"></app-risk-dashboard
    ></mat-tab>

    <!-- <mat-tab label="RISK PROFILE" *ngIf="false"
      ><app-risk-analytics-container
        [analyticsData]="analyticsState"
      ></app-risk-analytics-container
    ></mat-tab>
    <mat-tab label="VISITOR" *ngIf="false">
      <app-visitor-analytics-container
        (createVisitorTicket)="onCreateVisitorTicket($event)"
        [analyticsData]="analyticsState"
      ></app-visitor-analytics-container>
    </mat-tab>
    <mat-tab label="INCIDENT" *ngIf="false"
      ><app-incident-analytics-container
        (createIncidentTicket)="onCreateIncidentTicket($event)"
        [analyticsData]="analyticsState"
      ></app-incident-analytics-container
    ></mat-tab> -->
  </mat-tab-group>
</div>
<br />
<br />
<br />
<br />
<!-- Saving Dialog Content  -->
<ng-template #AnswerSavingDialog>
  <h2 matDialogTitle>Please wait!</h2>
  <mat-dialog-content>
    <i>Saving risk profile questions...</i>
    <mat-spinner></mat-spinner>
  </mat-dialog-content>
</ng-template>
